// Defers an audit-step entrance animation until the
// closest `data-audit-stage-target="stage"` ancestor
// has the `data-audit-stage-active` attribute set by
// the audit-stage controller.
//
// Why: the show page renders all six stage panels up
// front (hidden via CSS). Per-element controllers like
// `audit-reveal` connect immediately on page load, so
// playing their entrance in connect() means the tween
// runs against an invisible element and finishes
// before the user ever sees the stage. Wait for the
// stage to flip active, THEN play.
//
// Returns a `disconnect` function that cancels the
// pending wait (call from the controller's
// `disconnect()`).
//
// If the element is not inside a stage (e.g. used on
// the landing page hero), the play function fires
// immediately and disconnect is a no-op.
export function whenStageActive(element, play) {
  const stage = element.closest(
    '[data-audit-stage-target="stage"]'
  );

  if (!stage) {
    play();
    return () => {};
  }

  if (stage.hasAttribute("data-audit-stage-active")) {
    play();
    return () => {};
  }

  const observer = new MutationObserver(() => {
    if (stage.hasAttribute("data-audit-stage-active")) {
      observer.disconnect();
      play();
    }
  });

  observer.observe(stage, {
    attributes: true,
    attributeFilter: ["data-audit-stage-active"],
  });

  return () => observer.disconnect();
}
